import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import NProgress from 'nprogress'
import configureStore from './redux/configureStore'
import App from './App'
import reportWebVitals from './reportWebVitals'
import 'nprogress/nprogress.css'
import './main.less'
import './macarons.js'

NProgress.configure({ showSpinner: false, trickleSpeed: 200 })

const store = configureStore()

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
